import { listingsApiV1 } from '@app/services'

import { FetchProjectsTotalResponse } from './types'

export const fetchPublishedProjectsTotal = async (): Promise<number> => {
  try {
    const { data } = await listingsApiV1.get<FetchProjectsTotalResponse>(
      'projects',
      {
        params: {
          'query.mode': 'OnlyTotal',
          'query.filters.state': 'Published',
        },
      }
    )

    return data.total
  } catch (error) {
    console.error('Failed to fetch published projects total', error)
    return 0
  }
}
